import { store } from '@/store'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext, RouteRecordName } from 'vue-router'

export default async function (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext
) {
  try {
    const isDeepLink = window.localStorage.getItem('fromDeepLink') || (to.query['itemID'] && to.query['orgID'])
    const adminRoutes: RouteRecordName[] = ['settings-team-settings']
    const sessionModule = store.state.session
    const isAdminRoute = to.name !== undefined && adminRoutes.includes(to.name)

    if (sessionModule.userRole !== 'admin' && isAdminRoute && (isDeepLink || from.name === undefined)) {
      window.localStorage.removeItem('fromDeepLink')
      return next({ name: 'not-admin-error' })
    } else if (sessionModule.userRole !== 'admin' && isAdminRoute && from.name !== undefined) {
      return next({ name: 'settings-profile-settings' })
    } else return next()
  } catch {
    return next({ name: 'getstarted' })
  }
}
